import { render, staticRenderFns } from "./schoolterms.vue?vue&type=template&id=252c8000&"
import script from "./schoolterms.vue?vue&type=script&lang=js&"
export * from "./schoolterms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports